const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgePracticaIdUsuariIdAnalyze = async (
    idPrac: string,
    idUser: string,
    dubteContext: string,
    idAula: string,
    adminId: string
) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${idPrac}/usuaris/${idUser}/analyze`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id_usuari: adminId,
                id_aula: idAula,
                dubte: dubteContext
            })
        });
        if (response.ok) {
            return await response.json();
        } else {
            return null;
        }
    } catch (e) {
        return null;
    }
};
